import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchUser, logoutUser } from "../../store/actions";
import { withFirebase } from "./Firebase";
import { compose } from "recompose";
import { App, injectGlobalStyle, injectResetStyle } from "reactackle";

class App2 extends Component {
  constructor(props) {
    super(props);
    console.log("running app jsx constructor");
    //this.props.fetchUser();
  }

  _logOut() {
    this.props.logoutUser().then(data => {
      // reload props from reducer
      this.props.fetchUser();
    });
  }

  onComponentDidMount() {
    injectGlobalStyle();
    injectResetStyle();
  }

  render() {
    return <App fixed={true}>{this.props.children}</App>;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchUser, logoutUser }, dispatch);
}

function mapStateToProps(state) {
  return { currentUser: state.db.userProfile };
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(App2);



// WEBPACK FOOTER //
// ./src/app/components/app.jsx